var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.67 10.19L14 6.34C13.1746 5.86581 12.1591 5.86696 11.3348 6.34303C10.5104 6.8191 10.0019 7.69806 10 8.65L6.00004 6.34C5.1746 5.86581 4.15913 5.86696 3.33477 6.34303C2.51041 6.8191 2.00188 7.69806 2.00004 8.65V16.35C1.99507 17.3007 2.50358 18.1801 3.33004 18.65C3.73504 18.8922 4.19813 19.0201 4.67004 19.02C5.1371 19.0175 5.59547 18.8934 6.00004 18.66L10 16.35C9.99567 17.3032 10.5035 18.1852 11.33 18.66C12.1556 19.139 13.1745 19.139 14 18.66L20.67 14.81C21.4939 14.3325 22.0011 13.4523 22.0011 12.5C22.0011 11.5477 21.4939 10.6675 20.67 10.19ZM10 14.04L5.00003 16.92C4.79463 17.0363 4.54318 17.036 4.33811 16.9191C4.13305 16.8022 4.00461 16.586 4.00003 16.35V8.65001C4.00461 8.41401 4.13305 8.19784 4.33811 8.08095C4.54318 7.96406 4.79463 7.9637 5.00003 8.08001L10 10.96V14.04ZM19.6701 13.04L13.0001 16.93C12.7917 17.0457 12.5384 17.0457 12.3301 16.93C12.1232 16.8106 11.997 16.5888 12.0001 16.35V8.65C11.997 8.41121 12.1232 8.18939 12.3301 8.07C12.4351 8.01451 12.5514 7.98373 12.6701 7.98C12.7863 7.979 12.9005 8.01014 13.0001 8.07L19.6701 11.92C19.8771 12.0398 20.0047 12.2608 20.0047 12.5C20.0047 12.7392 19.8771 12.9603 19.6701 13.08V13.04Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNext);
export default __webpack_public_path__ + "static/media/play-next.ff77d2fc.svg";
export { ForwardRef as ReactComponent };